<template>
<transition>
	<div v-if="is_loading_page" key="is-loading-page" class="box-loading">
		<div class="spinner-border text-primary" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>
	<div class="page" v-else key="page-loaded">
		<div class="page-header">
			<div class="row">
				<div class="col col-6">
					<div class="page-title">
						Sample data
					</div>
				</div>
				<div class="col col-6">
					<div class="text-right">
						<router-link class="btn btn-primary" :to="{name: 'CreateSampleMessage'}">Create Sample Message</router-link>
						<router-link class="btn btn-primary m-l-30" :to="{name: 'CreateSampleTheme'}">Create Sample Theme</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="page-body m-t-30">
			<div class="m-t-50">
				<ul class="vue-tabs">
					<li :class="{ 'is-active' : type == 'message'}">
						<router-link :to="{ name : 'Sample'}">Content</router-link>
					</li>
					<li :class="{ 'is-active' : type == 'theme'}">
						<router-link :to="{ name : 'Sample' , query :{ type : 'theme'}}">Theme</router-link>
					</li>
				</ul>
				<transition name="fade" mode="out-in">
					<div class="box-loading" v-if="is_loading" key="is-loading">
						<div class="spinner-border text-primary" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
					<div class="m-t-20 list-item-message row" v-else key="is-loading-success">
						<template v-if="data.length">
							<div class="col col-4 m-b-30" v-for="(item, index) in data" :key="`index_item_${index}`">
								<div class="item-message">
									<template v-if="item.type =='message'">
										<offer-preview :is-sample="true" :message="item.data" :theme="defaultData.theme_setting"></offer-preview>
									</template>
									<template v-if="item.type =='theme'">
										<offer-preview :is-sample="true" :message="defaultData.message" :theme="item.data.theme_setting"></offer-preview>
									</template>
									<div class="item-message-btn">
										<button class="btn btn-secondary btn-icon" @click.stop.prevent="remove(item.id)">
											<i class="fal fa-trash-alt"></i>
										</button>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="col col-12">
								<div class="text-center p-t-30 p-b-30">
									<h3>Data not found </h3>
								</div>
							</div>
						</template>
					</div>
				</transition>
			</div>
		</div>
	</div>
</transition>
</template>

<script>
import OfferPreview from '@/views/offers/partials/offer-preview'
import { mapActions, mapGetters } from "vuex";
export default {
  name: "VueSample",
  	components: {
		OfferPreview
  	},

  	data() {
  		return {
			data: [],
			is_loading: false,
			is_loading_page : false,
			type : 'message',
			form : {
				"message": [],
				"theme":{
					"theme_setting": {},
					"is_custom_css": false,
					"custom_css": "",
				},
				"content" :{
					"setting_time_type": "date",
					"date_format": "MM/DD/YYYY",
					"shipping_day": [0,6],
					"delivered_day": [0,6],
					"currency": "",
					"currency_type" : "name",
					"convert_currency": true,
				},
			}
  		};
  	},

  	computed: {
		...mapGetters({
			defaultData : 'offer/getDefaultData'
		})
  	},

  	methods: {
  		...mapActions({
			getSample: "setting/getSample",
			delete: "setting/deleteSample",
			update: "setting/updateSample",
		}),
		load(route){
			this.is_loading = true 
			var type = route.query && route.query.type ? route.query.type : 'message' 
			if( type != 'message' && type != 'theme'){
				type = 'message'
			} 
			this.type = type
			this.data = []
			this.getSample({type}).then(res=>{
				let { status , data } = res.data 
				if( status ){
					if( type == 'message'){
						this.data = data.map((item)=>{
							item['data'] = this.$helper.convertToShortcode(item.data)
							return item
						})
					}else{
						this.data = data
					}
					
				}
			})
			.finally(()=>{
				this.is_loading_page = false
				this.is_loading = false 
			})
		},
		reload(){
			this.load(this.$route)
		},
		remove(id){
			this.$confirm.show({
				title : 'Warning',
				content : 'Do you want to delete this sample ?',
				contentType : 'text',
				btnClose : 'Cancel',
				btnCloseClass : 'btn btn-secondary',
				onClose : null ,
				btnSave : 'Delete',
				btnSaveClass : 'btn btn-primary',
  				onSave:  ()=>{
  					return new Promise( (resolve, reject)=>{
  						this.delete(id)
						.then(res => {
							let { status , message } = res.data 
							if( status ){
								this.$toast({
									title: "",
									message:'Delete sample successfully !',
									icon: "fal fa-check",
									type: 'success',
									time : 2000
								});
								this.reload();
							}
						})
						.catch(res => {
							
						})
						.finally(() => {
							resolve();
						});
  						
  					});
  				}
			})
		},
		
  	},
	beforeRouteUpdate(to, from, next) {
  		this.load(to);
  		next();
  	},
  	created() {
		this.is_loading_page = true
		this.load(this.$route)
  	}
};
</script>

<style lang="scss" scoped>
	.list-item-message{
		.item-message{
			position: relative;
			&-btn{
				position: absolute;
				top: 5px;
				right: 5px;
				z-index: 100;
				.btn + .btn{
					margin-left: 10px;
				}
			}
		}
	}
</style>